import React from 'react';
import { ReworkCtx, useReworkCtx } from './rework-ctx';

export function ReworkCtxProvider(props: { children: React.ReactNode }) {
  const reworkCtx = useReworkCtx();

  return (
    <ReworkCtx.Provider value={reworkCtx}>{props.children}</ReworkCtx.Provider>
  );
}
